import { Box, useTheme } from "@mui/material";
import { assignmentTypeToIconMap } from "./equipmentDropdown.constants";
import type { Assignment } from "./EquipmentDropdown.types";

interface AssignmentTypeIconProps {
  assignmentType: NonNullable<Assignment>["type"];
  size?: "small" | "medium";
}

export const AssignmentTypeIcon = ({
  assignmentType,
  size = "medium",
}: AssignmentTypeIconProps) => {
  const theme = useTheme();

  const iconSize = size === "small" ? 20 : 24;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        maxWidth: iconSize,
        maxHeight: iconSize,
        color: theme.palette.grey[600],
        backgroundColor: theme.palette.grey[50],
        borderRadius: 1,
        padding: 0.25,
      }}
    >
      {assignmentTypeToIconMap[assignmentType]}
    </Box>
  );
};
